module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-14-1.v1.jpg";